// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3hzKg","content":"LayoutSettings_content__1d_K2"};